import { useEffect } from "react";

const useAttachmentButton = (attButton, customStore) => {
  useEffect(() => {
    const attachmentButton = document.getElementsByClassName(
      "webchat__upload-button"
    )[0];
    if (attButton) {
      attachmentButton?.classList.remove("hidden");
    } else {
      attachmentButton?.classList.add("hidden");
    }
  }, [attButton, customStore]);
};

export default useAttachmentButton;
